/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Osteopathy_TermsInputs */

const en_service_type_osteopathy_terms = /** @type {(inputs: Service_Type_Osteopathy_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`osteopath, osteopathy`)
};

const pl_service_type_osteopathy_terms = /** @type {(inputs: Service_Type_Osteopathy_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`osteopata, osteopatia`)
};

/**
* | output |
* | --- |
* | "osteopath, osteopathy" |
*
* @param {Service_Type_Osteopathy_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_osteopathy_terms = /** @type {((inputs?: Service_Type_Osteopathy_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Osteopathy_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_osteopathy_terms(inputs)
	return en_service_type_osteopathy_terms(inputs)
});